import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

export const TabBarStateContext = createContext();

export const TabBarStateProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const value = useMemo(
    () => ({ isLoaded, setIsLoaded }),
    [isLoaded, setIsLoaded]
  );
  return (
    <TabBarStateContext.Provider value={value}>
      {children}
    </TabBarStateContext.Provider>
  );
};

TabBarStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
